import { lazy } from 'react';

const LazyHubSpotOAuthCallbackPage = lazy(() => import('./hubspot-oauth-callback-page'));
export default LazyHubSpotOAuthCallbackPage;
